import React, { useCallback, useState } from "react";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import CheckBox from "../../../../Button/CheckBox";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";
import Flex from "../../../../DefaultStyles/Flex";
import LineBox from "../../../../DefaultStyles/LineBox";
import { OptionType } from "../../../../Filters/DropDown";
import {
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
} from "../../UserBoard/IndateSection";
import { payHistoryFilterState } from "../PayHistorySection";

interface PayHistorySectionFilterProps {
  optionList: OptionType[];
}

export default function PayHistorySectionFilter({
  optionList,
}: PayHistorySectionFilterProps) {
  const [checked, setChecked] = useState<OptionType[]>([]);

  const setTypeValue = useSetRecoilState(payHistoryFilterState);

  const objByDetail = optionList.reduce((group: any, product: any) => {
    const { category } = product;

    group[category] = group[category] ?? [];
    group[category].push(product);

    return group;
  }, {});

  const arrByDetail = Object.entries(objByDetail);

  const filteredData = arrByDetail.filter((data) => {
    const category = data[0] as string;

    return category !== "";
  });

  // 개별 체크 클릭 시 발생하는 함수
  const onCheckedElement = useCallback(
    (targetChecked: any, list: any, isChecked: any) => {
      console.log(targetChecked, list, isChecked);

      if (!isChecked) {
        if (targetChecked) {
          setChecked([...checked, list]);
        } else {
          setChecked(checked.filter((el: any) => el !== list));
        }
      } else {
        setChecked(
          checked.filter((el: any) => {
            return el.value !== list.value;
          })
        );
      }
    },
    [checked]
  );

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>거래 내역 필터 선택</DashBoardSectionTitle>

        <Flex gapSize={10}>
          <LineBtn
            btnText="초기화"
            icon="refresh"
            sPadding="0 10px"
            btnHeight={38}
            btnClickEvent={() => {
              setChecked([]);
              setTypeValue([]);
            }}
            disabled={checked?.length === 0}
          />

          <ConfirmBtn
            btnText="필터 적용"
            btnColor="mint"
            btnHeight={38}
            btnClickEvent={() => {
              setTypeValue(checked);
            }}
            isDisabled={checked?.length === 0}
          />
        </Flex>
      </DashBoardSectionTitleContainer>

      <LineBox>
        <FilterContainer>
          {filteredData?.map((d, i) => {
            const category = d[0] as string;
            const categorizedData = d[1] as {
              value: string;
              label: string;
              category: string;
            }[];

            return (
              <CategoryItemContainer>
                <Category>{category}</Category>

                <CheckBoxContainer>
                  <>
                    {categorizedData?.map((d, i) => {
                      const isChecked = checked.find(
                        (el) => el.value === d.value
                      );
                      return (
                        <CheckBox
                          checked={isChecked ? true : false}
                          key={i}
                          label={d.label}
                          onChange={(event: {
                            target: { checked: any; value: any };
                          }) => {
                            onCheckedElement(
                              event.target.checked,
                              d,
                              isChecked ? true : false
                            );
                          }}
                        />
                      );
                    })}
                  </>
                </CheckBoxContainer>
              </CategoryItemContainer>
            );
          })}
        </FilterContainer>
      </LineBox>
    </>
  );
}

const FilterContainer = styled.div``;

const CategoryItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 24px;
  gap: 24px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const Category = styled.label`
  margin-top: 8px;
  width: 60px;
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: left;
`;

const CheckBoxContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-column-gap: 20px;
`;
